import React from 'react';
import { ScrollReveal } from './ScrollReveal';
import { Lightbulb, Rocket, Settings, DollarSign } from 'lucide-react';
import { SectionCTA } from './SectionCTA';
export function ProgramPhases() {
  const phases = [{
    id: 1,
    title: 'Oportunidad y Validación',
    icon: <Lightbulb className="w-6 h-6" data-id="element-256" />,
    color: 'cyan',
    items: ['Cómo elegir qué vender', 'Cómo detectar problemas reales', 'Cómo validar sin gastar dinero', 'Cómo saber si alguien pagaría antes de crear']
  }, {
    id: 2,
    title: 'Creación Express',
    icon: <Rocket className="w-6 h-6" data-id="element-257" />,
    color: 'purple',
    items: ['Cómo estructurar tu producto en 72 horas', 'Qué formato usar (ebook, guía, reto)', 'Cómo organizar el contenido', 'Cómo fijar precio estratégico']
  }, {
    id: 3,
    title: 'Sistema de Ventas',
    icon: <Settings className="w-6 h-6" data-id="element-258" />,
    color: 'green',
    items: ['Arquitectura mínima de monetización', 'Link + checkout + cierre simple', 'Hooks psicológicos y guiones', 'Estrategia de lanzamiento rápido']
  }, {
    id: 4,
    title: 'Ventas y Escalamiento',
    icon: <DollarSign className="w-6 h-6" data-id="element-259" />,
    color: 'amber',
    items: ['Cómo cerrar por DM', 'Manejo de objeciones', 'Cómo reinvertir', 'Cómo convertirlo en sistema repetible']
  }];
  const getColorClass = (color: string) => {
    switch (color) {
      case 'cyan':
        return 'text-cyan-400 bg-cyan-400/10 border-cyan-400/20';
      case 'purple':
        return 'text-purple-400 bg-purple-400/10 border-purple-400/20';
      case 'green':
        return 'text-green-400 bg-green-400/10 border-green-400/20';
      case 'amber':
        return 'text-amber-400 bg-amber-400/10 border-amber-400/20';
      default:
        return 'text-white bg-white/10 border-white/20';
    }
  };
  return <section className="py-24 px-4 bg-[#050510] relative" data-id="element-260">
      <div className="container mx-auto max-w-5xl" data-id="element-261">
        <ScrollReveal className="text-center mb-16" data-id="element-262">
          <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-263">
            Estructura del Programa
          </h2>
          <p className="text-gray-400" data-id="element-264">Un camino claro, paso a paso.</p>
        </ScrollReveal>

        <div className="space-y-8 relative" data-id="element-265">
          {/* Vertical line for desktop */}
          <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-cyan-500/0 via-cyan-500/50 to-cyan-500/0 -translate-x-1/2" data-id="element-266" />

          {phases.map((phase, index) => <ScrollReveal key={phase.id} direction={index % 2 === 0 ? 'left' : 'right'} className={`flex flex-col md:flex-row gap-8 items-center ${index % 2 !== 0 ? 'md:flex-row-reverse' : ''}`} data-id="element-267">
              {/* Card */}
              <div className="flex-1 w-full" data-id="element-268">
                <div className={`glass-card p-8 rounded-2xl border-l-4 ${phase.color === 'cyan' ? 'border-l-cyan-400' : phase.color === 'purple' ? 'border-l-purple-400' : phase.color === 'green' ? 'border-l-green-400' : 'border-l-amber-400'}`} data-id="element-269">
                  <div className={`inline-flex items-center gap-2 px-3 py-1 rounded-full text-sm font-bold mb-4 ${getColorClass(phase.color)}`} data-id="element-270">
                    {phase.icon}
                    FASE {phase.id}
                  </div>
                  <h3 className="text-2xl font-bold mb-4" data-id="element-271">{phase.title}</h3>
                  <ul className="space-y-2" data-id="element-272">
                    {phase.items.map((item, i) => <li key={i} className="flex items-start gap-2 text-gray-400 text-sm" data-id="element-273">
                        <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-gray-600 flex-shrink-0" data-id="element-274" />
                        {item}
                      </li>)}
                  </ul>
                </div>
              </div>

              {/* Center Marker */}
              <div className="hidden md:flex items-center justify-center w-12 h-12 rounded-full bg-[#050510] border-2 border-white/10 z-10 relative" data-id="element-275">
                <div className={`w-4 h-4 rounded-full ${phase.color === 'cyan' ? 'bg-cyan-400' : phase.color === 'purple' ? 'bg-purple-400' : phase.color === 'green' ? 'bg-green-400' : 'bg-amber-400'}`} data-id="element-276" />
              </div>

              {/* Empty space for opposite side */}
              <div className="flex-1 hidden md:block" data-id="element-277" />
            </ScrollReveal>)}
        </div>

        <SectionCTA headline="Empieza la Fase 1 hoy mismo" buttonText="COMENZAR EL PROGRAMA" data-id="element-278" />
      </div>
    </section>;
}